import React from 'react';
import Routing from './Routing.js';

function App() {
    return (
        <div className="clanleaderboard">
            <Routing/>
        </div>
    );
}

export default App;
